export default {
   // user permissions data 
   intiPermissions(state, permissions = null) {
      state.permissions = modifyColumnNames(permissions);
   },
}